import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import AddPrivacyPolicy from "./AddPrivacyPolicy";
import WebService from "../../utility/WebService";

const PrivacyPolicy = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState<any>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  const getPrivacyPolicy = () => {
    WebService.getAPI({
      action: `privacy-policy/detail`,
    })
      .then((res: any) => {

        setPrivacyPolicy(res.data.data);
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  return (
    <>
      <AddPrivacyPolicy
        show={showPrivacyPolicy}
        handleClose={() => {
          setShowPrivacyPolicy(false);
          getPrivacyPolicy();
        }}
        data={privacyPolicy}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Privacy Policy</div>
            {pagePermission.canEdit && (


              <CustomButton
                isLoading={false}
                label={privacyPolicy == null ? "Add" : "Edit"}
                onClick={() => {
                  setShowPrivacyPolicy(true);
                }}
                style={{ width: 100 }}
              />)}

          </div>
          {privacyPolicy == null ? (
            <div className="text-center mt-3">
              No Privacy policy information available
            </div>
          ) : (
            <span className="mt-3 d-block" style={{ padding: "20px 30px" }}>
              <img
                src={privacyPolicy?.image}
                alt="Privacy Policy"
                width={250}
              />
              <div className="ql-snow">
                <div
                  className="mt-2 px-0 ql-editor"
                  dangerouslySetInnerHTML={{ __html: privacyPolicy.description }}
                />
              </div>
              <hr />
            </span>
          )}
        </Card>
      </div>
    </>
  );
};

export default PrivacyPolicy;
